<template>
  <section class="mt-10">
    <div class="bg-white dark:bg-gray-800 relative shadow-md sm:rounded-lg overflow-hidden">
      <div class="border-b dark:border-gray-700 mx-4">
        <div class="flex items-center justify-between space-x-4 pt-3">
          <div class="flex-1 flex items-center space-x-3">
            <h5 class="dark:text-white font-semibold">
              Events
            </h5>
          </div>
        </div>
        <div class="flex flex-col-reverse md:flex-row items-center justify-between md:space-x-4 py-3">
          <div class="w-full lg:w-2/3 flex flex-col space-y-3 md:space-y-0 md:flex-row md:items-center">
            <form class="w-full md:max-w-sm flex-1 md:mr-4">
              <label
                class="text-sm font-medium text-gray-900 sr-only dark:text-white"
                for="event-search"
              >Search</label>
              <input
                id="event-search"
                v-model="searchQuery"
                class="block w-full p-2 pl-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                placeholder="Search events..."
                type="search"
              >
            </form>
          </div>
          <div
            class="w-full md:w-auto flex flex-col md:flex-row mb-3 md:mb-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0"
          >
            <button
              class="flex items-center justify-center text-white bg-black hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800"
              type="button"
              @click="openModal('newEvent')"
            >
              <svg
                class="h-3.5 w-3.5 mr-2"
                fill="none"
                height="12"
                viewBox="0 0 12 12"
                width="12"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 0.75V11.25M0.75 6H11.25"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                />
              </svg>
              Add New Event
            </button>
            <Modal
              :is-visible="modals.newEvent"
              modal-id="newEvent"
              max-width="sm:max-w-5xl"
              @update:is-visible="value => modals.newEvent = value"
            >
              <template #body>
                <div class="p-4">
                  <div class="flex flex-col items-center justify-center">
                    <h2 class="block text-2xl font-bold text-gray-800">
                      Add New Event
                    </h2>
                    <p class="mt-2 text-sm text-gray-600">
                      Create an event for members.
                    </p>
                  </div>
                  <div class="mt-6 grid gap-6 md:grid-cols-2">
                    <div>
                      <label class="block mb-2 text-sm font-medium text-gray-700">Title</label>
                      <input
                        v-model="form.title"
                        class="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary"
                        placeholder="Event title"
                        required
                        type="text"
                      >
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-medium text-gray-700">Location</label>
                      <input
                        v-model="form.location"
                        class="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary"
                        placeholder="City, venue, or online"
                        type="text"
                      >
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-medium text-gray-700">Date</label>
                      <input
                        v-model="form.date"
                        class="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary"
                        required
                        type="date"
                      >
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-medium text-gray-700">Type</label>
                      <input
                        v-model="form.type"
                        class="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary"
                        placeholder="Breakfast gathering"
                        type="text"
                      >
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-medium text-gray-700">Price (GBP)</label>
                      <input
                        v-model.number="form.price"
                        class="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary"
                        min="0"
                        placeholder="250"
                        step="0.01"
                        type="number"
                      >
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-medium text-gray-700">Ticket URL</label>
                      <input
                        v-model="form.ticketUrl"
                        class="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary"
                        placeholder="https://tickets.example.com"
                        type="url"
                      >
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-medium text-gray-700">Banner Image URL</label>
                      <input
                        v-model="form.bannerImageUrl"
                        class="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary"
                        placeholder="https://images.example.com/event-banner.jpg"
                        type="url"
                      >
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-medium text-gray-700">Banner Image Upload</label>
                      <input
                        accept="image/*"
                        class="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary"
                        type="file"
                        @change="handleBannerUpload"
                      >
                      <div class="mt-2">
                        <div
                          v-if="bannerUpload.status === 'uploading'"
                          class="text-xs text-gray-600"
                        >
                          Uploading banner... {{ bannerUpload.progress }}%
                        </div>
                        <div
                          v-else-if="bannerUpload.status === 'success'"
                          class="text-xs text-green-700"
                        >
                          Banner uploaded successfully.
                        </div>
                        <div
                          v-else-if="bannerUpload.status === 'error'"
                          class="text-xs text-red-600"
                        >
                          {{ bannerUpload.error }}
                        </div>
                        <div
                          v-if="bannerUpload.status === 'uploading'"
                          class="mt-2 h-2 w-full rounded-full bg-gray-200"
                        >
                          <div
                            class="h-2 rounded-full bg-black transition-all"
                            :style="{ width: `${bannerUpload.progress}%` }"
                          />
                        </div>
                        <div
                          v-if="bannerPreview.status === 'loading'"
                          class="mt-3 text-xs text-gray-600"
                        >
                          Loading banner preview...
                        </div>
                        <div
                          v-else-if="bannerPreview.status === 'error'"
                          class="mt-3 text-xs text-red-600"
                        >
                          {{ bannerPreview.error }}
                        </div>
                        <div
                          v-else-if="bannerPreview.status === 'ready'"
                          class="mt-3 space-y-2"
                        >
                          <img
                            alt="Banner preview"
                            class="w-full rounded-lg border border-gray-200"
                            :src="bannerPreview.url"
                          >
                          <button
                            class="text-xs font-semibold text-red-600 hover:text-red-700"
                            type="button"
                            @click="removeBanner"
                          >
                            Remove banner
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="md:col-span-2">
                      <label class="inline-flex items-center text-sm font-medium text-gray-700">
                        <input
                          v-model="form.hidePrice"
                          class="mr-2 h-4 w-4 rounded border-gray-300"
                          type="checkbox"
                        >
                        Hide price (show as paid event)
                      </label>
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-medium text-gray-700">Start Time</label>
                      <input
                        v-model="form.startTime"
                        class="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary"
                        type="time"
                      >
                    </div>
                    <div>
                      <label class="block mb-2 text-sm font-medium text-gray-700">End Time</label>
                      <input
                        v-model="form.endTime"
                        class="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary"
                        type="time"
                      >
                    </div>
                    <div class="md:col-span-2">
                      <label class="block mb-2 text-sm font-medium text-gray-700">Who Should Join</label>
                      <div class="grid gap-3 sm:grid-cols-2">
                        <label
                          v-for="option in whoShouldJoinOptions"
                          :key="option"
                          class="flex items-center gap-2 text-sm text-gray-700"
                        >
                          <input
                            v-model="form.whoShouldJoin"
                            class="h-4 w-4 rounded border-gray-300"
                            type="checkbox"
                            :value="option"
                          >
                          {{ option }}
                        </label>
                      </div>
                    </div>
                    <div class="md:col-span-2">
                      <label class="block mb-2 text-sm font-medium text-gray-700">Description</label>
                      <textarea
                        v-model="form.description"
                        class="block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary"
                        placeholder="Short summary for members"
                        rows="3"
                      />
                    </div>
                  </div>
                </div>
              </template>
              <template #footer>
                <div class="flex items-center">
                  <button
                    class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200"
                    type="button"
                    @click="closeModal('newEvent')"
                  >
                    Cancel
                  </button>
                  <button
                    class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-black text-white hover:bg-gray-700 disabled:opacity-50 disabled:pointer-events-none"
                    type="button"
                    :disabled="bannerUpload.status === 'uploading'"
                    @click="createEvent"
                  >
                    Add Event
                  </button>
                </div>
              </template>
            </Modal>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th
                class="px-4 py-3"
                scope="col"
              >
                Title
              </th>
              <th
                class="px-4 py-3"
                scope="col"
              >
                Date
              </th>
              <th
                class="px-4 py-3"
                scope="col"
              >
                Location
              </th>
              <th
                class="px-4 py-3"
                scope="col"
              >
                Type
              </th>
              <th
                class="px-4 py-3"
                scope="col"
              >
                Price
              </th>
              <th
                class="px-4 py-3"
                scope="col"
              >
                <span class="sr-only">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr class="border-b dark:border-gray-600">
              <td
                class="px-4 py-4 text-sm text-gray-500"
                colspan="6"
              >
                Loading events...
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="filteredEvents.length === 0">
            <tr class="border-b dark:border-gray-600">
              <td
                class="px-4 py-4 text-sm text-gray-500"
                colspan="6"
              >
                {{ searchQuery ? 'No events match your search.' : 'No events created yet.' }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr
              v-for="event in filteredEvents"
              :key="event._id"
              class="border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <th
                class="px-4 py-2 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                scope="row"
              >
                <span>{{ event.title }}</span>
              </th>
              <td class="px-4 py-2 whitespace-nowrap">
                {{ formatDate(event.date) }}
              </td>
              <td class="px-4 py-2 whitespace-nowrap">
                {{ event.location || '—' }}
              </td>
              <td class="px-4 py-2 whitespace-nowrap">
                {{ event.type || '—' }}
              </td>
              <td class="px-4 py-2 whitespace-nowrap">
                <span v-if="event.hidePrice">Paid event</span>
                <span v-else-if="typeof event.price === 'number'">£{{ formatPrice(event.price) }}</span>
                <span v-else>—</span>
              </td>
              <td class="px-4 py-2 whitespace-nowrap">
                <div class="flex items-center gap-2">
                  <router-link
                    class="flex items-center justify-center w-10 h-10 text-gray-700 bg-white border border-gray-300 rounded-lg md:w-10 focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200"
                    :to="`/administrator/events/${event._id}`"
                    aria-label="Edit event"
                    title="Edit"
                  >
                    <svg
                      class="w-5 h-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        id="SVGRepo_bgCarrier"
                        stroke-width="0"
                      />
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <g id="SVGRepo_iconCarrier">
                        <g>
                          <g>
                            <g>
                              <g>
                                <g>
                                  <path
                                    d="M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8"
                                    fill="none"
                                    stroke="#000000"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                  />
                                  <polygon
                                    fill="none"
                                    points="12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8"
                                    stroke="#000000"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                  />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </router-link>
                  <button
                    class="flex items-center justify-center w-10 h-10 text-red-500 bg-white border border-red-400 rounded-lg md:w-10 focus:outline-none hover:bg-gray-100 hover:text-red-600 focus:z-10 focus:ring-4 focus:ring-gray-200"
                    type="button"
                    aria-label="Delete event"
                    title="Delete"
                    @click="deleteEvent(event._id)"
                  >
                    <svg
                      class="w-5 h-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g
                        id="SVGRepo_bgCarrier"
                        stroke-width="0"
                      />
                      <g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M4 7H20"
                          stroke="#ff5c5c"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        />
                        <path
                          d="M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10"
                          stroke="#ff5c5c"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        />
                        <path
                          d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                          stroke="#ff5c5c"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                        />
                      </g>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <nav
        aria-label="Table navigation"
        class="flex flex-col md:flex-row justify-between items-start md:items-center space-y-3 md:space-y-0 p-4"
      >
        <span class="text-sm font-normal text-gray-500 dark:text-gray-400">
          Showing <span class="font-semibold text-gray-900 dark:text-white">1-10</span> of <span class="font-semibold text-gray-900 dark:text-white">{{ filteredEvents.length }}</span>
        </span>
        <ul class="inline-flex items-stretch -space-x-px">
          <li>
            <a
              class="flex items-center justify-center h-full py-1.5 px-3 ml-0 text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >
              <span class="sr-only">Previous</span>
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewbox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  fill-rule="evenodd"
                />
              </svg>
            </a>
          </li>
          <li>
            <a
              class="flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >0</a>
          </li>
          <li>
            <a
              aria-current="page"
              class="flex items-center justify-center text-sm z-10 py-2 px-3 leading-tight text-primary-600 bg-primary-50 border border-primary-300 hover:bg-primary-100 hover:text-primary-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white"
              href="#"
            >1</a>
          </li>
          <li>
            <a
              class="flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >...</a>
          </li>
          <li>
            <a
              class="flex items-center justify-center text-sm py-2 px-3 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >1</a>
          </li>
          <li>
            <a
              class="flex items-center justify-center h-full py-1.5 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
              href="#"
            >
              <span class="sr-only">Next</span>
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewbox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  fill-rule="evenodd"
                />
              </svg>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </section>
</template>

<script lang="ts">
import {defineComponent, watchEffect} from 'vue';
import axios from 'axios';
import {Event} from '@/types';
import {useHead} from "@vueuse/head";
import Modal from '@/components/Modal.vue';

export default defineComponent({
  name: 'Events',
  components: {
    Modal,
  },
  setup() {
    watchEffect(() => {
      useHead({
        title: 'Events',
      });
    });
  },
  data() {
    return {
      events: [] as Event[],
      loading: false,
      error: '' as string,
      searchQuery: '',
      modals: {
        newEvent: false,
      },
      bannerUpload: {
        status: 'idle',
        progress: 0,
        error: null as string | null,
      },
      bannerPreview: {
        status: 'idle',
        url: '',
        error: null as string | null,
      },
      form: {
        title: '',
        location: '',
        date: '',
        startTime: '',
        endTime: '',
        type: '',
        price: undefined as number | undefined,
        hidePrice: false,
        ticketUrl: '',
        bannerImageUrl: '',
        whoShouldJoin: [] as string[],
        description: '',
      },
    };
  },
  computed: {
    filteredEvents(): Event[] {
      const query = this.searchQuery.trim().toLowerCase();
      if (!query) return this.events;
      return this.events.filter((event) => {
        return [
          event.title,
          event.location,
          event.type,
          event.description,
        ]
          .filter(Boolean)
          .some((value) => value!.toLowerCase().includes(query));
      });
    },
    whoShouldJoinOptions(): string[] {
      return [
        'VC Fund Managing Partners and Partners',
        'Crypto Fund Managing Partners and Partners',
        'Business Angels and Crypto Angel Investors',
        'Family Office Investment Team Members',
        'High Net Worth Individuals who are active LPs in Funds or Syndicates',
        'Sovereign Wealth Fund Managers',
        'Institutional Investors',
      ];
    },
  },
  async mounted() {
    await this.fetchEvents();
  },
  methods: {
    openModal(modalId: 'newEvent') {
      this.modals[modalId] = true;
    },
    closeModal(modalId: 'newEvent') {
      this.modals[modalId] = false;
    },
    async fetchEvents() {
      this.loading = true;
      try {
        const response = await axios.get<Event[]>('/events');
        this.events = response.data;
      } catch (err) {
        console.error(err);
        this.error = 'Failed to fetch events.';
      } finally {
        this.loading = false;
      }
    },
    async createEvent() {
      this.error = '';
      try {
        const response = await axios.post<Event>('/events', {
          title: this.form.title,
          location: this.form.location,
          date: this.form.date,
          startTime: this.form.startTime || undefined,
          endTime: this.form.endTime || undefined,
          type: this.form.type || undefined,
          price: typeof this.form.price === 'number' ? this.form.price : undefined,
          hidePrice: this.form.hidePrice,
          ticketUrl: this.form.ticketUrl || undefined,
          bannerImageUrl: this.form.bannerImageUrl || undefined,
          whoShouldJoin: this.form.whoShouldJoin.length ? this.form.whoShouldJoin : undefined,
          description: this.form.description || undefined,
        });
        this.events = [...this.events, response.data].sort((a, b) => {
          return new Date(a.date).getTime() - new Date(b.date).getTime();
        });
        this.form = {
          title: '',
          location: '',
          date: '',
          startTime: '',
          endTime: '',
          type: '',
          price: undefined,
          hidePrice: false,
          ticketUrl: '',
          bannerImageUrl: '',
          whoShouldJoin: [],
          description: '',
        };
        this.resetBannerUpload();
        this.resetBannerPreview();
        this.closeModal('newEvent');
      } catch (err) {
        console.error(err);
        this.error = 'Failed to create event.';
      }
    },
    async deleteEvent(id: string) {
      this.error = '';
      try {
        await axios.delete(`/events/${id}`);
        this.events = this.events.filter((item) => item._id !== id);
      } catch (err) {
        console.error(err);
        this.error = 'Failed to delete event.';
      }
    },
    async handleBannerUpload(event: globalThis.Event) {
      const input = event.target as HTMLInputElement;
      const file = input.files?.[0];
      if (!file) return;

      this.bannerUpload = {
        status: 'uploading',
        progress: 0,
        error: null,
      };

      const formData = new FormData();
      formData.append('image', file);

      try {
        const response = await axios.post<{ imageUrl: string }>('/upload/banner', formData, {
          onUploadProgress: (progressEvent) => {
            const total = progressEvent.total || 0;
            const percent = total ? Math.round((progressEvent.loaded / total) * 100) : 0;
            this.bannerUpload = {
              status: 'uploading',
              progress: percent,
              error: null,
            };
          },
        });
        this.form.bannerImageUrl = response.data.imageUrl;
        this.bannerUpload = {
          status: 'success',
          progress: 100,
          error: null,
        };
        await this.loadBannerPreview();
      } catch (err) {
        console.error('Failed to upload banner:', err);
        this.bannerUpload = {
          status: 'error',
          progress: 0,
          error: 'Banner upload failed. Please try again.',
        };
      }
    },
    async loadBannerPreview() {
      if (!this.form.bannerImageUrl) {
        this.resetBannerPreview();
        return;
      }

      const raw = this.form.bannerImageUrl.trim();
      if (raw.startsWith('http://') || raw.startsWith('https://')) {
        this.bannerPreview = {
          status: 'ready',
          url: raw,
          error: null,
        };
        return;
      }

      this.bannerPreview = {
        status: 'loading',
        url: '',
        error: null,
      };

      try {
        const response = await axios.get<{ url: string }>(
          `/video/get-signed-url?fileName=${encodeURIComponent(this.form.bannerImageUrl)}`
        );
        this.bannerPreview = {
          status: 'ready',
          url: response.data.url,
          error: null,
        };
      } catch (err) {
        console.error('Failed to load banner preview:', err);
        this.bannerPreview = {
          status: 'error',
          url: '',
          error: 'Failed to load banner preview.',
        };
      }
    },
    removeBanner() {
      this.form.bannerImageUrl = '';
      this.resetBannerPreview();
    },
    resetBannerUpload() {
      this.bannerUpload = {
        status: 'idle',
        progress: 0,
        error: null,
      };
    },
    resetBannerPreview() {
      this.bannerPreview = {
        status: 'idle',
        url: '',
        error: null,
      };
    },
    formatPrice(value: number) {
      return value.toFixed(2);
    },
    formatDate(value: string) {
      if (!value) return 'Unknown date';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return 'Unknown date';
      return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      }).format(date);
    },
    formatTimeRange(start?: string, end?: string) {
      if (start && end) return `${start} to ${end}`;
      if (start) return `From ${start}`;
      if (end) return `Until ${end}`;
      return '';
    },
  },
});
</script>
